import styles from 'css/src/components/sketch/SketchProjectOption.module.scss';

import React from 'react';

import type { Project } from 'js/src/client';
import ProjectIcon from 'js/src/components/dashboard/ProjectIcon';
import type { DeepReadonly } from 'js/src/libs/consts';

const SelectedCheck: React.FC = () => (
    <i translate="no" className={`material-symbols-outlined ${styles['project-option__check']}`}>
        check
    </i>
);

const ProjectOptionContent: React.FC<{ project: DeepReadonly<Project>; selected: boolean }> = ({
    project,
    selected,
}) => (
    <span className={`${styles['project-option']} d-flex align-items-center`}>
        <ProjectIcon
            iconName={project.icon}
            iconBgColor={project.color}
            iconClassName={styles['project-option__icon']}
        />
        <span className="text-truncate flex-fill">{project.name}</span>
        {selected && <SelectedCheck />}
    </span>
);

const NoProjectOptionContent: React.FC<{ selected: boolean }> = ({ selected }) => (
    <span className={`${styles['project-option']} d-flex align-items-center`}>
        <i
            translate="no"
            className={`material-symbols-outlined ${styles['project-option__icon--none']}`}
        >
            folder_off
        </i>
        <span className="text-truncate flex-fill">No project</span>
        {selected && <SelectedCheck />}
    </span>
);

export const buildProjectDropdownItems = <T extends object>(
    buildOnSelectData: (projectId: number | null) => T,
    projects: readonly DeepReadonly<Project>[],
    selectedProjectId: number | null,
    { allowNoProject }: { allowNoProject: boolean },
) => {
    const items = projects.map((project) => {
        const isSelected = project.id === selectedProjectId;
        return {
            id: `project-${project.id}`,
            text: '',
            className: styles['project-option-item'],
            active: isSelected || undefined,
            onSelectData: buildOnSelectData(project.id),
            children: <ProjectOptionContent project={project} selected={isSelected} />,
        };
    });

    if (allowNoProject) {
        const isSelected = selectedProjectId === null;
        items.push({
            id: 'project-none',
            text: '',
            className: styles['project-option-item'],
            active: isSelected || undefined,
            onSelectData: buildOnSelectData(null),
            children: <NoProjectOptionContent selected={isSelected} />,
        });
    }

    return items;
};
